import {Injectable, EventEmitter} from '@angular/core';
// import * as signalR from '@aspnet/signalr';
import * as signalR from '@microsoft/signalr';
import {environment} from '../../../../environments/environment';
import {MbsNotification} from '../../models/notification.model';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class SignalRService {
    private hubConnection: signalR.HubConnection;
    private hubConnectionStatistic: signalR.HubConnection;
    // private restarter: NodeJS.Timeout;
    updatedCardApplicationStatus = new EventEmitter<any>();
    receivedPersonelNotification = new EventEmitter<MbsNotification>();
    receivedGeneralNotification = new EventEmitter<MbsNotification>();
    changedVisitors = new EventEmitter<any[]>();

    receivedRemainingData = new EventEmitter<string>();
    receivedLogoutUser = new EventEmitter();
    receivedReloadUserBrowser = new EventEmitter();

    constructor(private router: Router) {
    }

    buildConnection() {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(environment.signalRUrl, {
                accessTokenFactory: () => localStorage.getItem(environment.authTokenKey)
            })
            .configureLogging(environment.production ? signalR.LogLevel.Warning : signalR.LogLevel.Debug)
            .withAutomaticReconnect([100, 500, 1000, 1000, 3000, 3000, 5000, 5000, 10000, 10000, 10000, 30000, 30000, 50000])
            .build();

        this.hubConnection.onreconnecting((error) => {
            console.assert(this.hubConnection.state === signalR.HubConnectionState.Reconnecting);
            // console.log(`Bir hata nedeniyle bağlantı kesildi: "${error}". Yeniden bağlantı deneniyor.`);
        });
        this.hubConnection.onreconnected((connectionId) => {
            console.assert(this.hubConnection.state === signalR.HubConnectionState.Connected);
            // console.log(`Bağlantı yeniden sağlandı. Bağlantı Id: "${connectionId}".`);
        });
        this.hubConnection.onclose((error) => {
            console.assert(this.hubConnection.state === signalR.HubConnectionState.Disconnected);
            // console.log(`Bağlantı hata nedeniyle koptu: "${error}". Yeniden bağlanmak için sayfayı yenileyiniz.`);
        });
    }

    buildStatisticConnection() {
        this.hubConnectionStatistic = new signalR.HubConnectionBuilder()
            .withUrl(environment.signalRStatisticUrl)
            .configureLogging(environment.production ? signalR.LogLevel.Warning : signalR.LogLevel.Debug)
            .withAutomaticReconnect([100, 500, 1000, 1000, 3000, 3000, 5000, 5000, 10000, 10000, 10000, 30000, 30000, 50000])
            .build();
        this.hubConnectionStatistic.onreconnecting((error) => {
            console.assert(this.hubConnectionStatistic.state === signalR.HubConnectionState.Reconnecting);
            // console.log(`Bir hata nedeniyle bağlantı kesildi: "${error}". Yeniden bağlantı deneniyor.`);
        });
        this.hubConnectionStatistic.onreconnected((connectionId) => {
            console.assert(this.hubConnectionStatistic.state === signalR.HubConnectionState.Connected);
            // console.log(`Bağlantı yeniden sağlandı. Bağlantı Id: "${connectionId}".`);
            this.changeLocation(this.router.url);
        });
        this.hubConnectionStatistic.onclose((error) => {
            console.assert(this.hubConnectionStatistic.state === signalR.HubConnectionState.Disconnected);
            // console.log(`Bağlantı hata nedeniyle koptu: "${error}". Yeniden bağlanmak için sayfayı yenileyiniz.`);
        });
    }

    startConnection() {
        this.hubConnection
            .start()
            .then(() => {
                this.registerSignalEvents();
            })
            .catch((err) => {
                if (err && err.statusCode && err.statusCode === 401) {
                    console.clear();
                    this.stopConnection().then(() => {
                        // console.log('Bağlantı durduruldu.');
                    });
                } else {
                    // console.log(`Bağlantı başlatılırken bir hata oluştu: ${err}.`);
                }
            });
    }

    startStatisticConnection() {
        this.hubConnectionStatistic
            .start()
            .then(() => {
                this.registerSignalStatisticEvents();
            })
            .catch((err) => {
                if (err && err.statusCode && err.statusCode === 401) {
                    console.clear();
                    this.stopStatisticConnection().then(() => {
                        // console.log('Bağlantı durduruldu.');
                    });
                } else {
                    // console.log(`Bağlantı başlatılırken bir hata oluştu: ${err}.`);
                }
            });
    }

    stopConnection() {
        // console.log('Bağlantı durdurma deneniyor.');
        return this.hubConnection.stop();
    }

    stopStatisticConnection() {
        // console.log('Bağlantı durdurma deneniyor.');
        return this.hubConnectionStatistic.stop();
    }

    private registerSignalEvents() {
        this.hubConnection.on('UpdatedCardApplicationStatus', () => {
            this.updatedCardApplicationStatus.emit();
        });
        this.hubConnection.on('ReceivedPersonalNotification', (notification: MbsNotification) => {
            this.receivedPersonelNotification.emit(notification);
        });
        this.hubConnection.on('ReceivedGeneralNotification', (notification: MbsNotification) => {
            this.receivedGeneralNotification.emit(notification);
        });
        this.hubConnection.on('ReceivedRemaining', (remaining: string) => {
            this.receivedRemainingData.emit(remaining);
        });
    }

    private registerSignalStatisticEvents() {
        this.hubConnectionStatistic.on('VisitorCame', (visitors: any[]) => {
            if (!environment.production) {
                console.log('Ziyaretçi geldi. Toplam: ' + visitors.length);
            }
            this.changedVisitors.emit(visitors);
        });
        this.hubConnectionStatistic.on('VisitorLeft', (visitors: any[]) => {
            if (!environment.production) {
                console.log('Ziyaretçi ayrıldı. Toplam: ' + visitors.length);
            }
            this.changedVisitors.emit(visitors);
        });
        this.hubConnectionStatistic.on('ChangedLocation', (visitors: any[]) => {
            if (!environment.production) {
                console.log('Ziyaretçiler', visitors);
            }
            this.changedVisitors.emit(visitors);
        });
        this.hubConnectionStatistic.on('ReceivedReloadUserBrowser', () => {
            this.receivedReloadUserBrowser.emit();
        });
        this.hubConnectionStatistic.on('ReceivedLogoutUser', (visitors: any[]) => {
            this.receivedLogoutUser.emit();
        });
    }

    public changeLocation(currentLocation: string): void {
        if (this.hubConnectionStatistic.state === signalR.HubConnectionState.Connected) {
            if (!environment.production) {
                console.log('change location: direct');
            }
            this.hubConnectionStatistic.invoke('ChangeLocation', currentLocation).then();
        } else {
            if (this.hubConnectionStatistic.state === signalR.HubConnectionState.Disconnected) {
                if (!environment.production) {
                    console.log('change location: disconnect');
                }
                this.startStatisticConnection();
            } else {
                setTimeout(() => {
                    if (this.hubConnectionStatistic.state === signalR.HubConnectionState.Connected) {
                        if (!environment.production) {
                            console.log('change location: settimeout connect');
                        }
                        this.hubConnectionStatistic.invoke('ChangeLocation', currentLocation).then();
                    }
                }, 1500);
            }

        }
    }
}
